import React, { useEffect, useState } from "react";
import KukariKillAnimation from "./KukariKillAnimation";
import kukariIcon from "../../../assets/blue-token-icon.svg";
import { BOARD_CONFIG, TOKEN_KILL_STEP_TIME, TWO_PLAYER_CONFIG } from "../constant";
import { getHeightCorrectedForIphone6, getWidth } from "../../../utils/relativeSizes";
import { calculateCoordinates } from "../utils";
import { _isNil } from "../../../utils/helpers/zupeeLodash";
import { useSelector } from "react-redux";
// import { getBoardType, getKilledKukari } from "../store/actions";
import { getEventProcessor } from "../../../pages/GamePlay/eventProcessor";
import { getKilledKukari, getTokenPosition } from "../../../store/selectors/ludoboardSelectors";

const KilledKukari = () => {
  const killedKukari = useSelector(getKilledKukari)
  const { tokenIndex, playerNumber } = killedKukari || {};
  const initialPosition = useSelector(getTokenPosition.bind(null, null, playerNumber, tokenIndex));
  const boardType = TWO_PLAYER_CONFIG;
  const [moveInfo, setMoveInfo] = useState<{ currentPosition: number; nextPosition: number } | null>(null);

  useEffect(() => {
    if (_isNil(killedKukari) || _isNil(initialPosition) || initialPosition <= 0) {
      setMoveInfo(null)
      return
    }
    if (_isNil(moveInfo)) {
      setMoveInfo({
        currentPosition: initialPosition,
        nextPosition: initialPosition - 1
      })
    } else {
      setTimeout(() => {
        if (moveInfo?.nextPosition === 0) {
          getEventProcessor()?.finishKillUserToken(initialPosition)
        } else {
          setMoveInfo(prevState => {
            if (prevState) {
              return {
                currentPosition: prevState.nextPosition,
                nextPosition: prevState.nextPosition - 1
              }
            } else {
              return prevState
            }
          })
        }
      }, TOKEN_KILL_STEP_TIME)
    }
  }, [initialPosition, killedKukari, moveInfo]);

  if (_isNil(moveInfo) || _isNil(playerNumber)) {
    return null
  }
  
  return (
    <KukariKillAnimation
      kukariImage={String(boardType?.KUKARI_IMAGE?.[playerNumber as 1] || '')}
      height={getHeightCorrectedForIphone6(28.2)}
      width={getWidth(16)}
      currentCoordinates={calculateCoordinates(playerNumber, moveInfo.currentPosition)}
      nextCoordinates={calculateCoordinates(playerNumber, moveInfo.nextPosition)}
    />
  );
};

export default KilledKukari;
